(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["smart-3d-main_65d97005"] = factory();
	else
		root["smart-3d-main_65d97005"] = factory();
})(window, function() {
return 